import { useHistory } from 'react-router-dom';

/**
 * Custom hook to check if user's email is verified before proceeding with an action
 *
 * @param {Object} user - The current user object
 * @param {boolean} isAuthenticated - Whether the user is authenticated
 * @returns {Object} Object containing checkEmailVerification function
 */
const useEmailVerification = (user, isAuthenticated) => {
  const history = useHistory();

  /**
   * Checks if user needs email verification before executing a callback
   * If email is not verified, redirects to verification page
   * Otherwise, executes the provided callback
   *
   * @param {Function} callback - The function to execute if email is verified
   */
  const checkEmailVerification = callback => {
    if (isAuthenticated && user?.id) {
      const isEmailVerified = user.attributes?.emailVerified;
      if (!isEmailVerified) {
        // Redirect to email verification page
        history.push('/verify-email');
        return;
      }
    }
    // If email is verified or user is not authenticated, proceed with callback
    callback();
  };

  return { checkEmailVerification };
};

export default useEmailVerification;
